export const columns = [
    { label: 'accordion' },
    { label: 'quality' },
    { label: 'room' },
    { label: 'rate' },
    { label: 'meal_plan' },
    {
        label: 'LoS',
        sortableProps: { field: 'los', defaultDir: 'asc' },
    },
    {
        label: 'ari_last_updated',
        sortableProps: { field: 'datelastupdated', defaultDir: 'desc' },
    },
    { label: 'availability' },
];
